import { Component, inject, Input, OnDestroy, OnInit, Query, QueryList, ViewChildren } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatMenu, MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { SvgIconComponent, SvgIconRegistryService } from 'angular-svg-icon';
import { Subject, takeUntil } from 'rxjs';
import { HeaderContent } from '../../models/content/header-content.model';

@Component({
  selector: 'seth-header',
  imports: [
    MatButtonModule,
    MatToolbarModule,
    SvgIconComponent,
    MatMenuModule,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit, OnDestroy {
  svgRegistry: SvgIconRegistryService = inject(SvgIconRegistryService);
  _destroy$: Subject<boolean> = new Subject<boolean>()

  @ViewChildren(MatMenu) menus!: QueryList<MatMenu>;

  @Input() headerContent: HeaderContent = { 
    application: null,
    client: '',
    program: '',
    product: [],
    workflow: [],
    popupType: null,
    formName: '',
    programCode: '',
    dateRetrieved: new Date(),
  };
  @Input() isMobile: boolean = false;
  menuRefs: any;

  ngOnInit(): void {
    this.svgRegistry.loadSvg("../../assets/img/hamburg.svg", "hamburg")?.pipe(takeUntil(this._destroy$)).subscribe();
  }

  ngOnDestroy(): void {
    this._destroy$.next(true);
    this._destroy$.unsubscribe();
  }

  ngAfterViewInit(): void {
    this.menus.forEach((menu, index) => {
      this.menuRefs.set(`link${index}`, menu);
    });
  }
}
